import { forwardRef } from 'react';
import MuiDialogActions, { DialogActionsProps as MuiDialogActionsProps } from '@mui/material/DialogActions';
import { styled } from '@mui/material/styles';
import { DIALOG_SIDE_PADDINGS } from '../theme/constants';
import breakpoints from '../theme/breakpoints';
import { shouldForwardProp as sysShouldForwardProp } from '@mui/system';

export interface DialogActionProps extends MuiDialogActionsProps {
  justifyContent?: 'space-between';
  divider?: boolean;
}

const StyledDialogActions = styled(MuiDialogActions, {
  name: 'DialogActions',
  slot: 'Root',
  shouldForwardProp: (prop) => sysShouldForwardProp(prop) && prop !== 'divider' && prop !== 'justifyContent',
})<DialogActionProps>(({ theme, divider, justifyContent }) => ({
  justifyContent: justifyContent ?? 'flex-start',
  flexWrap: 'wrap',
  padding: `0 ${DIALOG_SIDE_PADDINGS.SM} 24px`,
  [theme.breakpoints.down('sm')]: {
    padding: `0 ${DIALOG_SIDE_PADDINGS.XS} 12px`,
  },
  ...(divider && {
    borderTop: `1px solid ${theme.palette.divider}`,
    padding: `12px ${DIALOG_SIDE_PADDINGS.SM} 16px`,
    [theme.breakpoints.down('sm')]: {
      padding: `12px ${DIALOG_SIDE_PADDINGS.XS}`,
    },
  }),
  '& > *': {
    [`@media only screen and (max-width: ${breakpoints.sm}px)`]: {
      flex: '0 0 100%',
    },
  },
}));

const DialogActions = forwardRef<HTMLDivElement, DialogActionProps>((props, ref) => {
  return (
    <StyledDialogActions ref={ref} {...props}>
      {props.children}
    </StyledDialogActions>
  );
});

DialogActions.displayName = 'DialogActions';

export default DialogActions;
